import { render } from "./ReferidosTercerNivel.vue?vue&type=template&id=5c1c5598"
import script from "./ReferidosTercerNivel.vue?vue&type=script&lang=js"
export * from "./ReferidosTercerNivel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__